(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/onboarding/assets/javascripts/events/delete-tooltip-event.js') >= 0) return;  svs.modules.push('/components/lb-utils/onboarding/assets/javascripts/events/delete-tooltip-event.js');
"use strict";

const VerifyType = svs.components.lbUtils.verify.constants.VerifyType;
const verifyObject = svs.components.lbUtils.verify.verifyObject;
const BaseTooltipEvent = svs.components.lbUtils.onboarding.events.BaseTooltipEvent;
const TooltipEventType = svs.components.lbUtils.onboarding.events.constants.TooltipEventType;
class DeleteTooltipEvent extends BaseTooltipEvent {
  constructor(props) {
    verifyObject(props).schema({
      target: VerifyType.NotEmptyString
    });
    super(TooltipEventType.Delete, props);
  }
}

setGlobal('svs.components.lbUtils.onboarding.events.DeleteTooltipEvent', DeleteTooltipEvent);

 })(window);